// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations

// imports --------------------------------------------------------------------
import * as Cookies from './0-cookies-v3.2.js';
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';
// import * as Example from './example.js';
import * as MyHistory from './wb-history-v2.0.js';
import * as MediaItems from './6-media-items-v1.7.js';
import * as VideoEmbed from './6-video-embed-v2.4.js';


// Import Swiper JS
import Swiper from 'swiper';
import { Controller, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';
// import 'swiper/modules/effect-fade.min.css';
Swiper.use([Controller, Navigation, Pagination]);

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------
let randomizerTimeout = null;
let timerInterval;
let countDownDate = '';

let prevSlideNr = -1;
let random;
let prevRandom;

// new page function ----------------------------------------------------------
export const setPage = () => {
  // sets all the pages
  // console.log('setPage');

  // polylang before local testing fix -------------------------------------------
  if (typeof $languages != 'undefined') {
    // set language switch urls
    Object.keys($languages).forEach(key => {
      const langEls = document.querySelectorAll('.js-lang-' + key);
      langEls.forEach(langEl => {
        langEl.setAttribute('href', $languages[key].url);
      });
    });

    // set active language item
    // change this per site, sets active item
    const langEl = document.querySelector('.js-lang-' + $language);
    if (langEl) langEl.classList.add('language__item--active');
  }

  // fix for local testing, before history in code ------------------------
  if (window.location.hostname.indexOf('192.168') > -1) {
    // replace in links
    const anchors = document.querySelectorAll('a');
    anchors.forEach(element => {
      const href = element.getAttribute('href');
      if (href) {
        const newLink = href.replace('localhost', window.location.hostname);
        element.setAttribute('href', newLink);
      }
    });

    // replace in forms
    const forms = document.querySelectorAll('form');
    forms.forEach(element => {
      const action = element.getAttribute('action');
      if (action) {
        const newLink = action.replace('localhost', window.location.hostname);
        element.setAttribute('action', newLink);
      }
    });

    // replace in images
    const imageEls = document.querySelectorAll('img');
    imageEls.forEach(imageEl => {
      const src = imageEl.getAttribute('data-src');
      if (src) {
        const newLink = src.split('localhost').join(window.location.hostname);
        imageEl.setAttribute('data-src', newLink);
      }

      const srcset = imageEl.getAttribute('data-srcset');
      if (srcset) {
        const newLink = srcset.split('localhost').join(window.location.hostname);
        imageEl.setAttribute('data-srcset', newLink);
      }
    });

    $baseUrl = $baseUrl.replace('localhost', window.location.hostname);
    $url = $url.replace('localhost', window.location.hostname);
    $assets = $assets.replace('localhost', window.location.hostname);
  }

  // setters -----------------------------------------------
  // if (typeof MyHistory !== 'undefined') MyHistory.historySetPage();
  // if ('setExample' in Example) Example.setExample();

  MediaItems.setMediaItems();

  const holderEl = document.querySelector('.page--' + $pageType + ' .page__sections');
  // console.log({ holderEl });
  if (holderEl && 'openVideoEmbeds' in VideoEmbed) {
    // console.log('openVideoEmbeds', { holderEl });
    VideoEmbed.openVideoEmbeds(holderEl, true);
  } 

  openSoundcloud();

  // start countdown timer ----------------------------
  const timerEl = document.querySelector('.timer');
  if (timerEl) {
    let attr = timerEl.getAttribute('data-moment');
    // console.log ({ attr });
    if (typeof attr !== 'undefined' && attr !== false) {
      // element has moment
      countDownDate = new Date(attr).getTime();

      // fix for times in the past
      if (countDownDate < Date.now()) {
        countDownDate = Date.now();
      }
    } else {
      // no moment in element
      countDownDate = Date.now() + 10000000;
    }

    timer();
    clearInterval(timerInterval);
    timerInterval = setInterval(timer, 1000);
  }

  // initialize randomizer sliders -----------------
  const sliderEls = document.querySelectorAll('.randomizer__slider');
  sliderEls.forEach(sliderEl => {
    const mySwiper = new Swiper(sliderEl, {
      direction: 'horizontal',
      loop: false,
      speed: 600,
      slidesPerView: 'auto',
      allowTouchMove: false,
    });

    // listerer after finishing the slide
    mySwiper.on('slideChange', mySwiper => {
      // console.log('slideChange', mySwiper);
      clearTimeout(randomizerTimeout);
      randomizerTimeout = setTimeout(fadeVisibleSlides, 600);
    });
  });

  randomizeSlides();
  clearTimeout(randomizerTimeout);
  setTimeout(fadeVisibleSlides, 1000);

  // initialize images sliders -----------------
  const campingSwiperEls = document.querySelectorAll('.images__swiper');
  campingSwiperEls.forEach(campingSwiperEl => {
    const imagesEl = campingSwiperEl.closest('.images');
    const mySwiper = new Swiper(campingSwiperEl, {
      direction: 'horizontal',
      loop: true,
      speed: 600,
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl: imagesEl.querySelector('.swiper-button-next'),
        prevEl: imagesEl.querySelector('.swiper-button-prev'),
      },
    });
  });

  // init news sliders -----------------
  const newsEls = document.querySelectorAll('.news');
  newsEls.forEach(newsEl => {
    const imagesEl = newsEl.querySelector('.news__slider--images');
    const textsEl = newsEl.querySelector('.news__slider--texts, .news__slider--text');
    const paginationEl = textsEl.querySelector('.swiper-pagination');

    const createNewsSwiper = (sliderEl, withNavigation, withPagination) => {
      if (!sliderEl) return null;
      return new Swiper(sliderEl, {
        direction: 'horizontal',
        loop: false,
        speed: 600,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        allowTouchMove: false,
        navigation: withNavigation
          ? {
            nextEl: newsEl.querySelector('.swiper-button-next'),
            prevEl: newsEl.querySelector('.swiper-button-prev'),
          }
          : false,
        pagination: withPagination
          ? {
            el: paginationEl,
            clickable: true,
          }
          : false,
      });
    };

    const imagesSwiper = createNewsSwiper(imagesEl, true, false);
    const textsSwiper = createNewsSwiper(textsEl, false, true);

    if (!imagesSwiper || !textsSwiper) return;

    imagesSwiper.controller.control = textsSwiper;
    textsSwiper.controller.control = imagesSwiper;
  });

  // switch ($pageType) {
  // }

  // Resize.setResize(true);
  if ('observerUnblocker' in Once) Once.observerUnblocker(); // calls setResize()

  // Once.fader -----------------------------------------------------
  // has to be called, because there is new content
  // must be after setting slick, because new elements are created
  setTimeout(() => {
    if ('fader' in Once) {
      // console.log('fader setFaders');
      Once.fader.setFaders();
    }
  }, 40); // more than once js fader delay
};

export const randomizeSlides = () => {
  prevSlideNr = -1;
  
  const sliderEls = document.querySelectorAll('.randomizer__slider');
  sliderEls.forEach(sliderEl => {
    const sliderNr = sliderEl.getAttribute('data-nr');

    // do the same for slider and black version of the slider
    if (prevSlideNr !== sliderNr) {
      const total = parseInt(sliderEl.getAttribute('data-total'), 10); 
      prevRandom = parseInt(sliderEl.dataset.random, 10);
      random = prevRandom;

      do {
        random = Math.floor(Math.random() * total);
      } while (random === prevRandom);
      sliderEl.dataset.random = random;
      
      prevSlideNr = sliderNr;
    }
    
    const swiper = sliderEl.swiper;
    swiper.slideTo(random);
  });
}

// countdown timer for the program ------------------------
const timer = () => {
  // Get today's date and time
  let now = new Date().getTime();

  // Find the timeDiff between now and the count down date
  let timeDiff = countDownDate - now;

  // console.log('timer', { countDownDate, now, timeDiff });

  // Time calculations for days, hours, minutes and seconds
  let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  let hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

  days = days.toString().length == 1 ? '0' + days : days;
  hours = hours.toString().length == 1 ? '0' + hours : hours;
  minutes = minutes.toString().length == 1 ? '0' + minutes : minutes;
  seconds = seconds.toString().length == 1 ? '0' + seconds : seconds;

  // Display the result in the element with id="demo"
  // document.getElementById("demo").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
  const daysEl = document.getElementById('timer-days');
  const hoursEl = document.getElementById('timer-hours');
  const minutesEl = document.getElementById('timer-minutes');
  const secondsEl = document.getElementById('timer-seconds');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  daysEl.textContent = days;
  hoursEl.textContent = hours;
  minutesEl.textContent = minutes;
  secondsEl.textContent = seconds;

  // If the count down is finished, write some text
  if (timeDiff < 0) {
    clearInterval(timerInterval);
    daysEl.textContent = '00';
    hoursEl.textContent = '00';
    minutesEl.textContent = '00';
    secondsEl.textContent = '00';
  }
}

const fadeVisibleSlides = () => {
  // console.log('fadeVisibleSlides');

  const randomizerSlideImgEls = document.querySelectorAll('.randomizer__slider--images .randomizer__slide img');
  randomizerSlideImgEls.forEach(imgEl => {
    const rect = imgEl.getBoundingClientRect();
    // visible horizontally
    if (rect.left < Resize.windowWidth && rect.right > 0 && !imgEl.classList.contains('fader2')) {
      imgEl.setAttribute('class', 'fader fader--loader fader--lazy fader--repeat fader--top');
    }
  });

  const randomizerSlideEls = document.querySelectorAll('.randomizer__slider--texts:not(.randomizer__slider--black) .randomizer__slide');
  randomizerSlideEls.forEach(slideEl => {
    const rect = slideEl.getBoundingClientRect();
    // visible horizontally
    if (rect.left < Resize.windowWidth && rect.right > 0 && !slideEl.classList.contains('fader2')) {
      slideEl.setAttribute('class', 'swiper-slide randomizer__slide fader fader--loader fader--lazy fader--repeat fader--top');
    }
  });


  if ('fader' in Once) Once.fader.setFaders();
}

export const openSoundcloud = () => {
  const soundcloudEl = document.querySelector('.soundcloud');

  if (soundcloudEl) {
    const blockedIframeEl = soundcloudEl.querySelector('.blocked-iframe');
    // console.log('openSoundcloud', {soundcloudEl, blockedIframeEl});
    if (!blockedIframeEl) return;

    if ('cookiesAcceptIframes' in Cookies && Cookies.cookiesAcceptIframes) {
      // paste soundscloud embed code here which is in the var $soundcloud
      soundcloudEl.insertAdjacentHTML('afterbegin', $soundcloud);

      blockedIframeEl.classList.remove('blocked-iframe--visible');
    } else {
      blockedIframeEl.classList.add('blocked-iframe--visible');
    }
  }
};
